module.exports = __webpack_public_path__ + "img/login-sub-chat.25722014.svg";